import { MembersService } from './members-service';

export default MembersService;
